import { Link } from "react-router-dom";
import { Card, Collapse, Group, Stack, Title } from "@mantine/core";
import {
  CurrencyBitcoin,
  CalendarEvent,
  DoorExit,
  Frame,
  PlayerPlay,
  QuestionMark,
  Run,
  Settings,
  Location,
  Trophy,
} from "tabler-icons-react";

import {
  ADMIN_NAV_BINGO,
  ADMIN_NAV_CLICK_AND_COLLECT,
  ADMIN_NAV_DIAPORAMAS,
  ADMIN_NAV_EVENTS,
  ADMIN_NAV_CROSSBAR,
  ADMIN_NAV_QUIZZES,
  ADMIN_NAV_WORKFORCE,
  ADMIN_NAV_HTML_PAGE,
  ADMIN_NAV_COLLAPSE_GAMES,
  ADMIN_NAV_COLLAPSE_SETTINGS,
  ADMIN_LOGOUT,
  ADMIN_NAV_PLACES,
  ADMIN_NAV_PRONOSTICSV2,
  ADMIN_NAV_CHAMPIONSHIPS,
  ADMIN_NAV_SONOMETER,
  // ADMIN_NAV_VOTE,
  //ADMIN_NAV_ROULETTE,
} from "_constants";
import {
  QUIZ_AUTHORISED_ORGANIZATIONS,
  QUIZ_AUTHORISED_ROLES,
  ADMIN_MENU_AUTHORIZED_ORGANIZATIONS,
  ADMIN_MENU_AUTHORIZED_ROLES,
} from "_roles";
import {
  ADMIN_BINGO_PATH,
  ADMIN_CLICK_AND_COLLECTS_PATH,
  ADMIN_CROSSBARS_PATH,
  ADMIN_EVENTS_PATH,
  ADMIN_HTML_PAGE_PATH,
  ADMIN_QUIZZES_PATH,
  ADMIN_WALLS_PATH,
  ADMIN_WORKFORCES_PATH,
  ADMIN_PLACES_PATH,
  ADMIN_PRONOSTICSV2_PATH,
  ADMIN_CHAMPIONSHIPS_PATH,
  ADMIN_SONOMETER_PATH,
} from "_urls";
import { AccessRights } from "common/admin/auth/AccessRights";
import { useQuizToken, useRole } from "common/admin/auth/hooks";

import foodMenu from "./food-menu.png";
//import VoteIcon from "./VoteIcon";
import HTMLPageIcon from "./HTMLPageIcon";
import { useDisclosure } from "@mantine/hooks";
//import WheelIcon from "./WheelIcon";

export function AdminMenuView() {
  const [, setQuizToken] = useQuizToken();
  const [, setRole] = useRole();
  const [opened1, { toggle: toggle1 }] = useDisclosure(false);
  const [opened2, { toggle: toggle2 }] = useDisclosure(false);

  return (
    <Stack className="h-full" my="xl">
      <AccessRights
        authorizedOrganizations={ADMIN_MENU_AUTHORIZED_ORGANIZATIONS}
        authorizedRoles={ADMIN_MENU_AUTHORIZED_ROLES}
      >
        <Link to={ADMIN_EVENTS_PATH} className="no-underline">
          <Card style={{ flex: 1 }}>
            <Group spacing="xl">
              <CalendarEvent size={50} />
              <Title order={3}>{ADMIN_NAV_EVENTS}</Title>
            </Group>
          </Card>
        </Link>
      </AccessRights>
      {/*Game*/}
      <Card style={{ flex: 1 }} onClick={toggle1} className="cursor-pointer">
        <Group spacing="xl">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={50}
            height={50}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="icon icon-tabler icons-tabler-outline icon-tabler-apps"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M4 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
            <path d="M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
            <path d="M14 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
            <path d="M14 7l6 0" />
            <path d="M17 4l0 6" />
          </svg>
          <Title order={3}>{ADMIN_NAV_COLLAPSE_GAMES}</Title>
        </Group>
      </Card>
      <Collapse in={opened1}>
        <div className="grid grid-cols-2">
          <Stack className="h-full">
            <AccessRights
              authorizedOrganizations={ADMIN_MENU_AUTHORIZED_ORGANIZATIONS}
              authorizedRoles={ADMIN_MENU_AUTHORIZED_ROLES}
            >
              <Link to={ADMIN_WALLS_PATH} className="no-underline">
                <Card style={{ flex: 1 }} className="mx-4">
                  <Group spacing="xl">
                    <PlayerPlay size={50} />
                    <Title order={3}>{ADMIN_NAV_DIAPORAMAS}</Title>
                  </Group>
                </Card>
              </Link>
            </AccessRights>
            <AccessRights
              authorizedOrganizations={ADMIN_MENU_AUTHORIZED_ORGANIZATIONS}
              authorizedRoles={ADMIN_MENU_AUTHORIZED_ROLES}
            >
              <Link to={ADMIN_CROSSBARS_PATH} className="no-underline">
                <Card style={{ flex: 1 }} className="mx-4">
                  <Group spacing="xl">
                    <Frame size={50} />
                    <Title order={3}>{ADMIN_NAV_CROSSBAR}</Title>
                  </Group>
                </Card>
              </Link>
            </AccessRights>
            <AccessRights
              authorizedOrganizations={ADMIN_MENU_AUTHORIZED_ORGANIZATIONS}
              authorizedRoles={ADMIN_MENU_AUTHORIZED_ROLES}
            >
              <Link to={`${ADMIN_BINGO_PATH}`} className="no-underline">
                <Card style={{ flex: 1 }} className="mx-4">
                  <Group spacing="xl">
                    <CurrencyBitcoin size={50} />
                    <Title order={3}>{ADMIN_NAV_BINGO}</Title>
                  </Group>
                </Card>
              </Link>
            </AccessRights>
            <AccessRights
              authorizedOrganizations={ADMIN_MENU_AUTHORIZED_ORGANIZATIONS}
              authorizedRoles={ADMIN_MENU_AUTHORIZED_ROLES}
            >
              <Link to={`${ADMIN_PRONOSTICSV2_PATH}`} className="no-underline">
                <Card style={{ flex: 1 }} className="mx-4">
                  <Group spacing="xl">
                    <svg
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      width="50"
                      height="50"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#000000"
                      stroke-width="1"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M6.73 17.018a8 8 0 1 1 10.54 0" />
                      <path d="M5 19a2 2 0 0 0 2 2h10a2 2 0 1 0 0 -4h-10a2 2 0 0 0 -2 2z" />
                      <path d="M11 7a3 3 0 0 0 -3 3" />
                    </svg>
                    <Title order={3}>{ADMIN_NAV_PRONOSTICSV2}</Title>
                  </Group>
                </Card>
              </Link>
            </AccessRights>
          </Stack>
          <Stack className="h-full">
            <AccessRights
              authorizedOrganizations={QUIZ_AUTHORISED_ORGANIZATIONS}
              authorizedRoles={QUIZ_AUTHORISED_ROLES}
            >
              <Link to={ADMIN_QUIZZES_PATH} className="no-underline">
                <Card style={{ flex: 1 }} className="mx-4">
                  <Group spacing="xl">
                    <QuestionMark size={50} />
                    <Title order={3}>{ADMIN_NAV_QUIZZES}</Title>
                  </Group>
                </Card>
              </Link>
            </AccessRights>

            <AccessRights
              authorizedOrganizations={ADMIN_MENU_AUTHORIZED_ORGANIZATIONS}
              authorizedRoles={ADMIN_MENU_AUTHORIZED_ROLES}
            >
              <Link to={ADMIN_HTML_PAGE_PATH} className="no-underline">
                <Card style={{ flex: 1 }} className="mx-4">
                  <Group spacing="xl" className="mx-4">
                    <HTMLPageIcon size={50} />

                    <Title order={3}>{ADMIN_NAV_HTML_PAGE}</Title>
                  </Group>
                </Card>
              </Link>
            </AccessRights>
            <AccessRights
              authorizedOrganizations={ADMIN_MENU_AUTHORIZED_ORGANIZATIONS}
              authorizedRoles={ADMIN_MENU_AUTHORIZED_ROLES}
            >
              <Link to={ADMIN_CLICK_AND_COLLECTS_PATH} className="no-underline">
                <Card style={{ flex: 1 }} className="mx-4">
                  <Group spacing="xl">
                    <img
                      src={foodMenu}
                      alt={ADMIN_NAV_CLICK_AND_COLLECT}
                      style={{ width: 50, height: 50 }}
                    />
                    <Title order={3}>{ADMIN_NAV_CLICK_AND_COLLECT}</Title>
                  </Group>
                </Card>
              </Link>
            </AccessRights>
            <AccessRights
              authorizedOrganizations={ADMIN_MENU_AUTHORIZED_ORGANIZATIONS}
              authorizedRoles={ADMIN_MENU_AUTHORIZED_ROLES}
            >
              <Link to={`${ADMIN_SONOMETER_PATH}`} className="no-underline">
                <Card style={{ flex: 1 }} className="mx-4">
                  <Group spacing="xl">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="50"
                      height="50"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="icon icon-tabler icons-tabler-outline icon-tabler-volume"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M15 8a5 5 0 0 1 0 8" />
                      <path d="M17.7 5a9 9 0 0 1 0 14" />
                      <path d="M6 15h-2a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2l3.5 -4.5a.8 .8 0 0 1 1.5 .5v14a.8 .8 0 0 1 -1.5 .5l-3.5 -4.5" />
                    </svg>
                    <Title order={3}>{ADMIN_NAV_SONOMETER}</Title>
                  </Group>
                </Card>
              </Link>
            </AccessRights>
          </Stack>
        </div>
      </Collapse>
      {/* settings */}
      <Card style={{ flex: 1 }} onClick={toggle2} className="cursor-pointer">
        <Group spacing="xl">
          <Settings size={50} />
          <Title order={3}>{ADMIN_NAV_COLLAPSE_SETTINGS}</Title>
        </Group>
      </Card>
      <Collapse in={opened2}>
        <div className="grid grid-cols-2">
          <Stack className="h-full">
            <AccessRights
              authorizedOrganizations={ADMIN_MENU_AUTHORIZED_ORGANIZATIONS}
              authorizedRoles={ADMIN_MENU_AUTHORIZED_ROLES}
            >
              <Link to={ADMIN_WORKFORCES_PATH} className="no-underline">
                <Card style={{ flex: 1 }} className="mx-4">
                  <Group spacing="xl">
                    <Run size={50} />
                    <Title order={3}>{ADMIN_NAV_WORKFORCE}</Title>
                  </Group>
                </Card>
              </Link>
            </AccessRights>
            <AccessRights
              authorizedOrganizations={ADMIN_MENU_AUTHORIZED_ORGANIZATIONS}
              authorizedRoles={ADMIN_MENU_AUTHORIZED_ROLES}
            >
              <Link to={ADMIN_CHAMPIONSHIPS_PATH} className="no-underline">
                <Card style={{ flex: 1 }} className="mx-4">
                  <Group spacing="xl">
                    <Trophy size={50} />
                    <Title order={3}>{ADMIN_NAV_CHAMPIONSHIPS}</Title>
                  </Group>
                </Card>
              </Link>
            </AccessRights>
          </Stack>
          <Stack className="h-full">
            <AccessRights
              authorizedOrganizations={ADMIN_MENU_AUTHORIZED_ORGANIZATIONS}
              authorizedRoles={ADMIN_MENU_AUTHORIZED_ROLES}
            >
              <Link to={ADMIN_PLACES_PATH} className="no-underline">
                <Card style={{ flex: 1 }} className="mx-4">
                  <Group spacing="xl">
                    <Location size={50} />
                    <Title order={3}>{ADMIN_NAV_PLACES}</Title>
                  </Group>
                </Card>
              </Link>
            </AccessRights>
          </Stack>
        </div>
      </Collapse>

      <div
        onClick={() => {
          setQuizToken(null);
          setRole(null);
        }}
        className="cursor-pointer"
      >
        <Card style={{ flex: 1 }}>
          <Group spacing="xl">
            <DoorExit size={50} />
            <Title order={3}>{ADMIN_LOGOUT}</Title>
          </Group>
        </Card>
      </div>
    </Stack>
  );
}
